import React from "react";

/**
 * Hausordnung-Seite
 * Enthält die Hausordnung für den Veranstaltungsraum Arenarisquelle
 * Regelt die Nutzung, Verhalten und Verantwortlichkeiten der Mieter
 */
export default function Hausordnung() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0D5C63] via-[#1A7A85] to-[#2D9DA6] py-12">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Hausordnung
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Veranstaltungsraum Arenarisquelle Bad Tabarz
          </p>
        </div>

        {/* Hauptinhalt */}
        <div className="bg-white rounded-xl shadow-2xl p-8 md:p-12">
          <div className="prose max-w-none text-gray-700">
            {/* Einleitung */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Hausordnung für die Nutzung des Veranstaltungsraums Arenarisquelle</h2>
              <p className="mb-4">
                Diese Hausordnung gilt für alle Nutzerinnen und Nutzer des Veranstaltungsraums, unabhängig davon, ob es sich um Privatpersonen, Unternehmen, Vereine oder Behörden handelt. Mit der Anmietung des Raumes erkennen Sie diese Regelungen verbindlich an.
              </p>
            </section>

            {/* 1. Allgemeines Verhalten */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Allgemeines Verhalten</h2>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>Der Raum ist pfleglich zu behandeln. Alle Einrichtungsgegenstände und technischen Anlagen sind sorgsam zu nutzen.</li>
                <li>Beschädigungen am Raum oder Inventar sind unverzüglich dem Vermieter zu melden.</li>
                <li>Die Reinigung nach der Nutzung obliegt dem Mieter, sofern nichts anderes vereinbart wurde.</li>
              </ul>
            </section>

            {/* 2. Rauchverbot */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Rauchverbot</h2>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>Das Rauchen ist nur außerhalb des Gebäudes erlaubt.</li>
                <li>Im gesamten Gebäude – einschließlich Eingangsbereich, Fluren, Toiletten und Veranstaltungsraum – gilt absolutes Rauchverbot.</li>
              </ul>
            </section>

            {/* 3. Verbot von offenem Feuer und Pyrotechnik */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Verbot von offenem Feuer und Pyrotechnik</h2>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>Offenes Feuer (z. B. Kerzen, Feuerkörbe, Grillgeräte etc.) ist innerhalb des Raumes nicht gestattet.</li>
                <li>Das Abbrennen von Pyrotechnik (z. B. Feuerwerkskörper, Bengalos, Knallkörper etc.) ist sowohl innerhalb als auch außerhalb des Gebäudes untersagt.</li>
                <li>Bei Zuwiderhandlung verfällt die gesamte hinterlegte Kaution. Zusätzlich behalten wir uns rechtliche Schritte vor.</li>
              </ul>
            </section>

            {/* 4. Lärmschutz und Nachtruhe */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Lärmschutz und Nachtruhe</h2>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>Ab 22:00 Uhr ist die Musik so zu reduzieren, dass sie ausschließlich innerhalb des Gebäudes hörbar ist.</li>
                <li>Die Nachtruhe ist zwingend einzuhalten. Eine Störung der Nachbarschaft ist in jedem Fall zu vermeiden.</li>
                <li>Fenster und Türen sind bei laufender Musik nach 22:00 Uhr geschlossen zu halten.</li>
              </ul>
            </section>

            {/* 5. Haftung */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Haftung</h2>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>Der Mieter haftet für alle durch ihn, seine Gäste oder beauftragte Dritte verursachten Schäden.</li>
                <li>Bei groben Verstößen gegen diese Hausordnung kann der Vermieter die Veranstaltung vorzeitig beenden.</li>
              </ul>
            </section>

            {/* 6. Sonstiges */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Sonstiges</h2>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>Der Raum darf nur für den vertraglich vereinbarten Zweck genutzt werden.</li>
                <li>Eine Untervermietung oder Weitergabe an Dritte ist nur mit vorheriger Zustimmung des Vermieters zulässig.</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
